import { handleActions } from 'redux-actions';
import { NotificationManager } from "react-notifications";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";

let url = 'resultados';
let form = 'ResultadosForm';
// ------------------------------------
// Constants
// ------------------------------------
export const constants = {
    LOADER: 'RESULTADOS_LOADER',
    DATA: 'RESULTADOS_DATA',
    ITEM_DATA: 'RESULTADOS_ITEM_DATA',
    TAB_EN_CURSO: 'RESULTADOS_TAB_EN_CURSO',
    SET_STEP: 'RESULTADOS_SET_STEP',
}

// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: constants.LOADER,
    loader,
});
const setData = data => ({
    type: constants.DATA,
    data,
});

const setItem = item => ({
    type: constants.ITEM_DATA,
    item,
});

// -----------------------------------
// Actions
// -----------------------------------
const getResultados = () => (dispatch) => {
    dispatch(setLoader(true));

    api.get(`${url}/get_reporte_resultados`)
        .then((response) => {
            dispatch(setData(response));
            dispatch(initializeForm(form, response.data));
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getDollar = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`administrative/get_dollar_exchange`).then((response) => {
        dispatch(setItem(response.dollar_exchange));
        dispatch(initializeForm(form, response.results));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}`, data).then((response) => {
        NotificationManager.success(response.detail, 'Éxito', 3000);
        dispatch(getResultados())
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};
const getSalesCostConfig = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${url}/get_costo_venta_real`).then((response) => {
        dispatch(initializeForm('SalesCostForm', response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editarModal = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${url}/${id}/update-sales-cost`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(getResultados())
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    dispatch({ type: constants.TAB_EN_CURSO, tab });
    dispatch(setLoader(false));
};
// Obtener resultados anuales

const getResultadosAnuales = () => (dispatch) => {
    dispatch(setLoader(true));

    api.get(`resultados-anuales/get_annual_resultados`)
        .then((response) => {
            dispatch(setData(response));
            dispatch(initializeForm(form, response.data));
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            NotificationManager.error((error && error.detail) ? error.detail : 'Error en lectura de datos', 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const getSalesCostConfigAnnual = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`resultados-anuales/get_porcentaje_de_crecimiento`).then((response) => {
        dispatch(initializeForm('ModalResultadosFormAnnual', response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const editarModalAnnual = (id=null, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`resultados-anuales/${id}/update-crecimiento`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(getResultadosAnuales())
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    editar,
    getResultados,
    getDollar,
    setTab,
    getSalesCostConfig,
    editarModal,
    getResultadosAnuales,
    getSalesCostConfigAnnual,
    editarModalAnnual
};

// -----------------------------------
// Reducers
// -----------------------------------
const reducers = {
    [constants.LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [constants.DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },

    [constants.ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [constants.TAB_EN_CURSO]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },
    [constants.CURRENCY]: (state, { currency }) => {
        return {
            ...state,
            currency,
        };
    },
};
export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    tab: 'RESULTADOS',
    currency: 'USD',

};
export default handleActions(reducers, initialState)
